import { NgIf } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatDivider } from '@angular/material/divider';
import { AgrPrimaryActionModule } from '@next/core-lib/components';
import { AgrI18nSharedModule } from '@next/core-lib/i18n';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { getSilosWithProductListRequest } from 'src/app/product/store/actions';

import { openEditSiloDialog } from '../../store/actions';

import { SilosTableComponent } from './components/silos-table/silos-table.component';

@Component({
  selector: 'app-silos',
  templateUrl: './silos.component.html',
  styleUrls: ['./silos.component.scss'],
  imports: [NgIf, MatButton, AgrPrimaryActionModule, MatDivider, SilosTableComponent, AgrI18nSharedModule],
})
export class SilosComponent implements OnInit, OnDestroy {
  private readonly destroy$ = new Subject<void>();

  constructor(private readonly store: Store) {}

  ngOnInit(): void {
    this.store.dispatch(getSilosWithProductListRequest());
  }

  addSilo(): void {
    this.store.dispatch(openEditSiloDialog({}));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
